import {
  CHECK_ACCESS_SUCCESS,
  CHECK_ACCESS_ERROR,
  DISMISS_MESSAGE,
  SAVE_URLS_PARAMS,
  SAVE_PATIENT_DETAILS,
  SAVE_CONSULT_NOTE_VISIBILITY,
  UPDATE_EBS_NUMBER,
  SET_REDO_ERX_LIST,
  IS_PATIENT_ONLINE,
  SAVE_APPOINTMENT_ID,
  SET_IS_PBS_AUTHORITY_REQUIRED,
  SET_IS_RE_AUTHENTICATION_REQUIRED,
  SET_PRESCRIBING_MESSAGE
} from "../constants/auth";

const initialState = {
  loading: false,
  success: false,
  error: false,
  message: "",
  haveAccess: false,
  consultNoteVisibility: false,
  urlParams: null,
  data: null,
  patientDetails: null,
  redoErxList: [],
  isPatientOnline: false,
  appointmentId: null,
  isPBSAuthorityRequired: false,
  isReAuthenticationRequired: false,
  ePrescribingMessage: ""
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CHECK_ACCESS_SUCCESS:
      return {
        ...state,
        success: false,
        error: false,
        haveAccess: true,
        loading: false,
        message: "",
        data: action.payload
      };
    case CHECK_ACCESS_ERROR:
      return {
        ...state,
        success: false,
        error: true,
        haveAccess: false,
        loading: false,
        message: action.payload,
        urlParams: null,
        data: null,
        patientDetails: null,
        consultNoteVisibility: false
      };
    case SAVE_URLS_PARAMS:
      return {
        ...state,
        urlParams: action.payload
      };
    case SAVE_PATIENT_DETAILS:
      if (action.payload && !action.payload.medicareNumber) {
        action.payload.medicareNumber = ""
      }
      if (action.payload && !action.payload.refNumerOnMedicareCard) {
        action.payload.refNumerOnMedicareCard = ""
      }
      return {
        ...state,
        patientDetails: action.payload
      };
    case SAVE_CONSULT_NOTE_VISIBILITY:
      return {
        ...state,
        consultNoteVisibility: action.payload
      };
    case DISMISS_MESSAGE:
      return {
        ...state,
        success: false,
        error: false,
        message: ""
      };
    case UPDATE_EBS_NUMBER:
      return {
        ...state,
        data: {
          ...state.data,
          ebsnumber: action.payload
        }
      };
    case SET_REDO_ERX_LIST:
      return {
        ...state,
        redoErxList: action.payload
      };
    case IS_PATIENT_ONLINE:
      return {
        ...state,
        isPatientOnline: action.payload
      };
    case SAVE_APPOINTMENT_ID:
      return {
        ...state,
        appointmentId: action.payload
      };
    case SET_IS_PBS_AUTHORITY_REQUIRED:
      return {
        ...state,
        isPBSAuthorityRequired: action.payload
      };
    case SET_IS_RE_AUTHENTICATION_REQUIRED:
      return {
        ...state,
        isReAuthenticationRequired: action.payload
      };
    case SET_PRESCRIBING_MESSAGE:
      return {
        ...state,
        prescribingMessage: action.payload
      };
    default:
      return state;
  }
}
